import theme from '@/style';
import {StyleSheet, View} from 'react-native';
import HeaderTab from './components/header-tab/header-tab';
import React from 'react';
import FilterIcon from '@/components/svgs/basic/filer';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';

import Text from '@/components/basic/text';
import {DownIcon} from '../casino/svg.variable';
import {useTranslation} from 'react-i18next';
import {currentBrand} from '@/brands';

const ResultHeder = ({
  currentType,
  onTypeChange,
  showFilter,
  onFilter,
}: {
  currentType: string;
  onTypeChange?: (v: string) => void;
  showFilter?: boolean;
  onFilter?: () => void;
}) => {
  const {i18n} = useTranslation();
  const isAnna = currentBrand.key === 'anna';

  return (
    <View style={[theme.background.white]}>
      <View
        style={[
          theme.flex.row,
          theme.flex.centerByCol,
          theme.flex.between,
          styles.headerWrap,
          isAnna && styles.annaHeaderWrap,
        ]}>
        <HeaderTab
          onChange={onTypeChange}
          selectedKey={currentType}
          options={[
            {label: i18n.t('home.tab.lottery'), value: 'Lottery'},
            {label: i18n.t('home.tab.casino'), value: 'Casino'},
          ]}
        />
        {showFilter && (
          <NativeTouchableOpacity
            onPress={onFilter}
            style={[
              theme.flex.row,
              theme.flex.centerByCol,
              styles.filterButton,
              isAnna && styles.annaFilterButton,
            ]}>
            <FilterIcon />
            <Text
              fontSize={14}
              style={isAnna ? styles.annaFilterText : undefined}>
              {i18n.t('filter.name')}
            </Text>
            <View>
              <DownIcon />
            </View>
          </NativeTouchableOpacity>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  headerWrap: {
    borderBottomColor: '#D8E0EA',
    borderBottomWidth: 1,
    paddingHorizontal: 12,
    paddingVertical: 12,
  },
  annaHeaderWrap: {
    minHeight: 56,
    paddingTop: 12,
    paddingBottom: 12,
  },
  filterButton: {
    gap: theme.paddingSize.xxs,
    borderWidth: 1,
    borderColor: '#D8E0EA',
    borderRadius: 4,
    paddingHorizontal: 8,
    height: 28,
  },
  annaFilterButton: {
    gap: 4,
  },
  annaFilterText: {
    letterSpacing: -0.2,
  },
});

export default ResultHeder;
